// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Checkbox_style_b-icon-warning__tmnAO","checkbox":"Checkbox_style_checkbox__eA24l","rotate":"Checkbox_style_rotate__iwuV3"};